import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sprout, X } from 'lucide-react';

const LAWN_URL = '/scarification-entretien-pelouse-vendee';
const KEY = 'lawn-season-banner-closed';

// Shown 1 Feb – 31 May (Paris time). "?banniere=pelouse" forces it for previews.
const inSeason = () => {
  const month = Number(new Intl.DateTimeFormat('fr-FR', { month: 'numeric', timeZone: 'Europe/Paris' }).format(new Date()));
  return month >= 2 && month <= 5;
};
// Upcoming spring: from June onwards the next spring is next year
const springYear = () => {
  const [m, y] = new Intl.DateTimeFormat('en-GB', { month: 'numeric', year: 'numeric', timeZone: 'Europe/Paris' }).format(new Date()).split('/').map(Number);
  return m >= 6 ? y + 1 : y;
};

export const LawnSeasonBanner = () => {
  const { search } = useLocation();
  const forced = new URLSearchParams(search).get('banniere') === 'pelouse';
  const [closed, setClosed] = useState(() => sessionStorage.getItem(KEY) === '1');

  if (closed || !(forced || inSeason())) return null;

  const close = () => { sessionStorage.setItem(KEY, '1'); setClosed(true); };

  return (
    <div className="bg-lime-400 text-emerald-900" data-testid="lawn-season-banner">
      <div className="container mx-auto px-4 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-sm relative pr-10">
        <p className="font-semibold flex items-center gap-2">
          <Sprout size={18} className="flex-shrink-0" />
          <span>Rénovation de pelouse : printemps {springYear()}. Scarification, regarnissage, engrais : dès 1,50 €/m² TTC.</span>
        </p>
        <div className="flex flex-wrap gap-2 sm:ml-auto">
          <Link to={`${LAWN_URL}#liste-printemps`} data-testid="lawn-banner-waitlist-btn" className="bg-emerald-800 text-white font-semibold rounded-full px-4 py-1.5 hover:bg-emerald-900 transition-colors">
            Rejoindre la liste d&apos;attente
          </Link>
          <Link to={`${LAWN_URL}#estimation`} data-testid="lawn-banner-estimate-btn" className="border border-emerald-800 font-semibold rounded-full px-4 py-1.5 hover:bg-emerald-800 hover:text-white transition-colors">
            Estimer mon prix
          </Link>
        </div>
        <button type="button" onClick={close} aria-label="Fermer" data-testid="lawn-banner-close" className="absolute right-3 top-2.5 p-1 rounded hover:bg-lime-300 transition-colors">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default LawnSeasonBanner;
